// extracted by mini-css-extract-plugin
module.exports = {"colorSelector":"styles_base_colorSelector__E8z42","colorOption":"styles_base_colorOption__WS3CS"};